<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>트레이 상세 정보 조회</h2>
      </div>
      <div class="table-btn center-right">
        <div>
          <button class="btn btn-140" @click="goList">트레이 리스트</button>
        </div>
        <div>
          <button class="btn btn-140" @click="deleteTray">
            <span v-if="!processing" class="process">트레이 삭제</span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
        <div>
          <button class="btn btn-140" @click="updateTray">트레이 수정</button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <div v-if="detailType === 'view'" class="table-content">
        <table>
          <tr>
            <td class="header">트레이 ID</td>
            <!-- TODO <td>{{ tray.trayAlias }}</td> -->
            <td>{{ tray.trayID }}</td>
          </tr>
          <tr>
            <td class="header">상품 이름</td>
            <td>{{ tray.product.productName }}</td>
          </tr>
          <tr>
            <td class="header">등록 상품 수</td>
            <td>{{ tray.product.currentCount }}</td>
          </tr>
          <tr>
            <td class="header">냉장고 ID</td>
            <!-- TODO <td>{{ tray.deviceAlias }}</td> -->
            <td>{{ tray.deviceID }}</td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">트레이 이름</td>
            <td>{{ tray.trayName }}</td>
          </tr>
          <tr>
            <td class="header">용량</td>
            <td>{{ tray.product.capacity }}</td>
          </tr>
          <tr>
            <td class="header">발주 상품 수</td>
            <td>{{ tray.product.orderCount }}</td>
          </tr>
          <tr>
            <td class="header">냉장고 이름</td>
            <td>{{ tray.deviceName }}</td>
          </tr>
        </table>
      </div>
      <div v-else-if="detailType === 'edit'" class="table-content">
        <table>
          <tr>
            <td class="header">트레이 ID</td>
            <!-- TODO <td><input type="text" v-model="editTray.trayAlias" /></td> -->
            <td> {{ editTray.trayID }} </td>
          </tr>
          <tr>
            <td class="header">상품 이름</td>
            <td><input type="text" readonly v-model="editTray.product.productName" /></td>
          </tr>
          <tr>
            <td class="header">냉장고 ID</td>
            <!-- TODO <td>{{ tray.deviceAlias }}</td> -->
            <td>{{ tray.deviceID }}</td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">트레이 이름</td>
            <td><input type="text" v-model="editTray.trayName" /></td>
          </tr>
          <tr>
            <td class="header">용량</td>
            <td><input type="number" v-model="editTray.product.capacity" /></td>
          </tr>
          <tr>
            <td class="header">냉장고 이름</td>
            <td>{{ tray.deviceName }}</td>
          </tr>
        </table>
      </div>

      <div v-if="detailType === 'edit'" class="table-btn center">
        <button
          class="btn btn-140 btn-blue-line" @click="excuteUpdate">
          <span v-if="!processing" class="process">수정</span>
          <ButtonLoading v-else></ButtonLoading>
        </button>
        <button
          class="btn btn-right"
          @click="cancelUpdate"
        >취소</button>
      </div>

      <div v-if="detailType === 'edit'" class="list" >
        <SearchConditions
          :tray="tray"
          @search="search"
        ></SearchConditions>
        <ProductList
          :tray="tray"
          :searchCondition="searchCondition"
          :searchEvent="searchEvent"
          @productDetail="productDetail"
        ></ProductList>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-bitwise */

import Configuration from '@/js/Configuration';
import ProductList from '@/components/product/ProductList';
import SearchConditions from '@/components/product/SearchConditions';
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  props: [
    'tray',
  ],
  components: {
    SearchConditions,
    ProductList,
    ButtonLoading,
  },
  data: () => ({
    detailType: 'view',
    editTray: null,
    searchCondition: null,
    searchEvent: 0,
    processing: false,
  }),
  methods: {
    updateTray() {
      this.editTray = JSON.parse(JSON.stringify(this.tray));
      this.detailType = 'edit';
    },
    async excuteUpdate() {
      if (this.tray.product && this.editTray.product &&
          !this.editTray.product.productID && this.tray.product.capacity !== this.editTray.product.capacity
      ) {
        alert('상품을 먼저 선택해 주세요');
        return;
      }
      try {
        this.processing = true;
        const url = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/tray/${this.tray.trayID}`;

        const param = {
          trayAlias: this.editTray.trayAlias,
          trayName: this.editTray.trayName,
          deviceID: this.editTray.deviceID,
        };
        const createResult = await this.$http.put(url,
          param,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        if (this.tray.product && this.editTray.product &&
          (this.tray.product.productID !== this.editTray.product.productID || this.tray.product.capacity !== this.editTray.product.capacity)
        ) {
          if (this.tray.product.productID) {
            await this.updateProduct();
          } else if (this.editTray.product.productID) {
            await this.addProduct();
          }
        }

        const device = {
          id: this.tray.deviceID,
          name: this.tray.deviceName,
          alias: this.tray.deviceAlias,
        };
        this.processing = false;
        this.$emit('refreshList', device, 'device', 1);
      } catch (e) {
        this.processing = false;
        console.error(e);
      }
    },
    cancelUpdate() {
      this.detailType = 'view';
    },
    async deleteTray() {
      this.processing = true;
      const tray = await this.$getTray(this.tray.trayID, true);
      if (!tray) {
        alert('존재하지 않는 트레이입니다.');
        this.processing = false;
        return;
      } else if (tray.dependence) {
        alert('사용중인 트레이는 삭제할 수 없습니다.\n"냉장고 관리" 및 "재고 관리"를 확인해 주세요.');
        this.processing = false;
        return;
      }

      if (!confirm('정말 삭제하시겠습니까?')) {
        this.processing = false;
        return;
      }

      try {
        const url = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/tray/${this.tray.trayID}`;

        const createResult = await this.$http.delete(url,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        this.processing = false;

        const device = {
          id: this.tray.deviceID,
          name: this.tray.deviceName,
          alias: this.tray.deviceAlias,
        };
        this.$emit('refreshList', device, 'device', 1);
      } catch (e) {
        if (e.response.status === 403) {
          alert('사용중 입니다.');
        } else {
          console.error(e);
        }
        this.processing = false;
      }
    },
    goList() {
      const device = {
        id: this.tray.deviceID,
        name: this.tray.deviceName,
        alias: this.tray.deviceAlias,
      };
      this.$emit('refreshList', device, 'device', 1);
    },
    productDetail(product) {
      if (this.editTray) {
        this.editTray.product = product;
      }
    },
    async addProduct() {
      try {
        const ret = await this.$http.post(`${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/tray/${this.tray.trayID}/product`,
        {
          deviceID: this.tray.deviceID,
          trayID: this.tray.trayID,
          productID: this.editTray.product.productID,
          capacity: parseInt(this.editTray.product.capacity, 10),
        },
        {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (ret.status !== 200) {
          throw new Error(`Response status is "${ret.status}"`);
        }
        if (ret.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${ret.data.resultCode}"`);
        }
      } catch (e) {
        console.error(e);
      }
    },
    async updateProduct() {
      try {
        const ret = await this.$http.put(`${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/tray/${this.tray.trayID}/product`,
        {
          deviceID: this.tray.deviceID,
          trayID: this.tray.trayID,
          productID: this.editTray.product.productID,
          capacity: parseInt(this.editTray.product.capacity, 10),
        },
        {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (ret.status !== 200) {
          throw new Error(`Response status is "${ret.status}"`);
        }
        if (ret.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${ret.data.resultCode}"`);
        }
      } catch (e) {
        console.error(e);
      }
    },
    search(condition) {
      this.searchCondition = condition;
      this.searchEvent ^= 1;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tray/TrayDetail.vue